import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css'; 
import 'tailwindcss/tailwind.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Footer from './components/Footer';
import Header from './components/Header';
import Home from './pages/Home';
import NotFound from './pages/404';
import About from './pages/About';
import Solution from './pages/Solution';
import News from './pages/News';
import NewsDetail from './pages/NewsDetail/NewsDetail';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import TermsUse from './pages/TermsUse/TermsUse';
import './i18n'; 
import './App.css';


const App = () => {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/solutions" element={<Solution />} />
        <Route path="/News" element={<News />} />
        <Route path="News/detail" element={<NewsDetail />} />
        <Route path="/politique-confidentialite" element={<PrivacyPolicy />} />
        <Route path="/conditions-utilisation" element={<TermsUse />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </div>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);